import http from "../utils/http";

export const addThirdPartyMessnger = (params) => {
  return new Promise((resolve, reject) => {
    http
      .post(`/third-party-messenger`, params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getThirdPartyMessnger = () => {
  return new Promise((resolve, reject) => {
    http
      .get(`/third-party-messenger`)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const editThirdPartyMessnger = (idx, params) => {
  return new Promise((resolve, reject) => {
    http
      .put(`/third-party-messenger/${idx}`, params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
